import * as React from "react"

// SweetAlert2는 document.body에 .swal2-container를 직접 append하므로
// MutationObserver로 그 존재 여부를 관찰해 Radix Dialog/Sheet의 focus trap을
// 일시적으로 해제할지 판단하는 데 사용한다.
export function useSwalOpen() {
  const [swalOpen, setSwalOpen] = React.useState(false)

  React.useEffect(() => {
    const check = () => setSwalOpen(!!document.querySelector(".swal2-container"))
    check()
    const observer = new MutationObserver(check)
    observer.observe(document.body, { childList: true })
    return () => observer.disconnect()
  }, [])

  return swalOpen
}
